// 参考文档： http://mindoc.h5xiaomi.com:8283/docs/guojixiangqi/guojixiangqi-1eb7e1731l9dt
export const chessNameSpace = "Chess";

export enum SocketType {
    LOGIN = 'login',
    INVITE = 'invite',
    CHESS = 'chess',
    MATCH = 'match',
    LIVE = 'live',
    NOTIFY = 'notify',
    PING = 'ping',
    FRIEND = 'friend',
    CLOSE = 'close',
    OFFLINE = 'offline',
    SPRINT = 'sprint',
    SPRINT_PK = 'sprintPk',
}

export enum SocketCategory {
    LOGIN = 'login',
    SUCCESS = 'success',
    FAIL = 'fail',
    STATUS = 'status',
    TALK = 'talk',
    DRAW = 'draw',
    BACK = 'back',
    SURRENDER = 'surrender',
    OVER = 'over',
    UPDATE = 'update',
    NOTIFY = 'notify',
    PING = 'ping',
    APPLY = 'apply',
    CLOSE = 'close',
    OFFLINE = 'offline',
    MOVE = 'move',
}
